import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { IconClose, IconSearch } from "../../icons";
import { Input } from "../../Input";
import { MenuModalSearch } from "../MenuModalSearch";
import { SearchContainer } from "../styles";
import { MENU_CONSTANTS } from "../../../utils/consts";
import { useState } from "react";
export var MenuSearch = function (_a) {
    var sideBarOpen = _a.sideBarOpen, searchInput = _a.searchInput, onSearchChange = _a.onSearchChange, onActiveSearchChange = _a.onActiveSearchChange, searchItems = _a.searchItems;
    var _b = useState(false), modalSearchOpen = _b[0], setModalSearchOpen = _b[1];
    var _c = useState(false), isSearchFocused = _c[0], setIsSearchFocused = _c[1];
    return (_jsxs(SearchContainer, { id: "menu-item/search", "$sideBarOpen": sideBarOpen, onMouseEnter: function () {
            if (!sideBarOpen) {
                setModalSearchOpen(true);
            }
        }, onMouseLeave: function () {
            if (!sideBarOpen) {
                setModalSearchOpen(false);
            }
        }, children: [sideBarOpen ? (_jsx(Input, { placeholder: MENU_CONSTANTS.SEARCH.PLACEHOLDER, iconLeft: _jsx(IconSearch, {}), iconRight: searchInput.length > 0 && (_jsx(IconClose, { onClick: function () { return onSearchChange(""); } })), value: searchInput, onChange: function (e) { return onSearchChange(e.target.value); }, onFocus: function () { return onActiveSearchChange(searchInput); } })) : (_jsx(IconSearch, {})), (modalSearchOpen || isSearchFocused) && (_jsx(MenuModalSearch, { searchItems: searchItems, setIsFocused: setIsSearchFocused }))] }));
};
//# sourceMappingURL=index.js.map